import { MBox, MHeading } from '../../../components/Monetize';
import { useLegalEntityLogo } from '../../../hooks/useLegalEntityLogo';
import ReadonlyCompanyLogo from '../../Quotes/Quote/CompanyLogo';
import { LegalEntityLogoUploader } from './components/LegalEntityLogoUploader';

interface LegalEntityLogoProps {
  isReadOnly: boolean;
  legalEntityId?: string;
  resetErrorState?: boolean;
}
export const LegalEntityLogo = ({
  isReadOnly,
  legalEntityId,
  resetErrorState = false,
}: LegalEntityLogoProps) => {
  const companyLogoData = useLegalEntityLogo({ id: legalEntityId });
  if (isReadOnly && companyLogoData.data) {
    return (
      <>
        <MHeading size="xs">Upload Logo</MHeading>
        <MBox mt={2} mb={4}>
          <ReadonlyCompanyLogo
            legalEntityId={legalEntityId}
            legalEntityLogoId={companyLogoData.data}
          />
        </MBox>
      </>
    );
  }
  return (
    <>
      <MHeading size="xs">Upload Logo</MHeading>
      <MBox mt={2} mb={4}>
        <LegalEntityLogoUploader
          legalEntityId={legalEntityId}
          companyLogoData={companyLogoData}
          resetErrorState={resetErrorState}
        />
      </MBox>
    </>
  );
};
